import { Helmet } from "react-helmet";

function GarantiaColchones(){
    return(
        <>
            <Helmet>
                <title>Garantía de productos - Colchones | Dormihogar</title>
            </Helmet>

            <main>
                <div className='block-container'>
                    <section className='block-content d-flex-center-center'>
                        <img src="/assets/imagenes/paginas/servicio-al-cliente/garantia-de-productos/colchones-2.png" alt=""/>
                    </section>
                </div>
            </main>
        </>
    )
}

export default GarantiaColchones;
